<template>
	<article class="flex-item is-small">
		<div class="card aircraft-card">

			<!-- Thumbnail -->
			<div class="aspect-ratio" style="--aspect-ratio:2/3;">
				<figure class="aircraft-thumb">
					<img :src="aircraft.featured_image_url" class="aircraft-img" />
				</figure>
			</div>

			<!-- Body -->
			<div class="aircraft-body">
				<h2 class="aircraft-title type--m">{{ aircraft.title.rendered }}</h2>
				<p class="aircraft-stat type--s">
					<span class="aircraft-stat-value type--b">Range: </span>{{ aircraft.meta.range }} Miles
				</p>
				<p class="aircraft-stat type--s">
					<span class="aircraft-stat-value type--b">Speed: </span>{{ aircraft.meta.speed }}mph
				</p>
			</div>

			<!-- Footer -->
			<div class="aircraft-footer type--s">
				<div class="aircraft-category">{{ tierNames }}</div>
				<p class="aircraft-capacity">
					<span class="aircraft-capacity-value">{{ aircraft.meta.capacity }}</span>
					<img src="@/assets/icons_person.svg" class="aircraft-stat-icon text-icon" />
				</p>
			</div>

		</div>
	</article>
</template>

<script>
export default {
	props: {
		aircraft: {
			type: Object,
		},
		tiers: {
			type: Array,
		},
	},

	computed: {
		tierNames() {
			let names = this.tiers.map((tier) => tier.name)
			return names.join(", ")
		},
	},
}
</script>

<style lang="scss" scoped>
// Remove 100% height to avoid flexbox issues
.aspect-ratio {
	height: auto;
}

.aircraft-card {
	display: flex;
	flex-direction: column;
	font-family: $type-sans;
	height: 100%;
}

.aircraft-thumb {
	background: #fff;
	border-bottom: 0.25rem solid $colour-teal--light;
	height: 100%;
	margin: 0;
	// position: relative;
}

.aircraft-img {
	display: block;
	height: calc( 100% - 1rem );
	left: 0.5rem;
	object-fit: cover;
	position: relative;
	top: 0.5rem;
	width: calc( 100% - 1rem );
}

.aircraft-body {
	background: $colour-stone;
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: center;
	padding: 1.25rem 0.75rem;
	text-align: center;
}

.aircraft-title {
	color: $colour-gold;
	font-family: $type-sans;
	font-weight: bold;
	letter-spacing: -0.5px;
	line-height: 1.1;
	margin: 0 0 0.5rem;
}

.aircraft-stat {
	line-height: 1.5;
	margin: 0;
}

.aircraft-stat-value {
	color: $colour-pencil;
}

.aircraft-footer {
	background: #fff;
	color: $colour-pencil;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 0.75rem 1rem;
}

.aircraft-category {
	margin: 0;
}

.aircraft-capacity {
	align-items: center;
	display: flex;
	flex-direction: row;
	margin: 0;
}

.aircraft-capacity-icon {
	display: flex;
	margin-left: 0.1em;
	svg {
		fill: currentColor;
		margin-top: -0.111111em;
	}
}
</style>
